import { render } from "./ktTopicInfo.vue?vue&type=template&id=603b71c7&scoped=true"
import script from "./ktTopicInfo.vue?vue&type=script&lang=js"
export * from "./ktTopicInfo.vue?vue&type=script&lang=js"

import "./ktTopicInfo.vue?vue&type=style&index=0&id=603b71c7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603b71c7"]])

export default __exports__